import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import { ref, unref, onMounted, nextTick, onBeforeUnmount, computed, watch } from 'vue-demi';
const { useEnv } = require('@fegobull/webapi').use;
const { isPreRender } = useEnv?.() || {};

export default (props) => {
    // swiper实例
    let swiperIns;
    // 当前激活
    const activeIndex = ref(0);
    // swiper节点
    const swiperRef = ref();

    // 以下配置在编辑器内改动，需要重新init
    const swiperOptions = computed(() => ({
        autoplay: props.autoplay,
        slides: props.list,
        children: props.tpl.children,
        autoplayDelay: props.autoplayDelay,
        swiperWidth: props.swiperWidth,
        swiperHeight: props.swiperHeight
    }));

    const destroySwiper = () => {
        swiperIns?.destroy();
    };

    const initSwiper = () => {
        destroySwiper();
        const $swiper = unref(swiperRef);
        const { slides, autoplay, autoplayDelay } = swiperOptions.value;
        // 延迟时间（提供是配置单位是s）
        const delay = autoplayDelay * 1000;
        if (slides?.length && $swiper) {
            swiperIns = new Swiper($swiper, {
                modules: [Autoplay],
                initialSlide: activeIndex.value,
                direction: 'vertical',
                slidesPerView: 1,
                autoHeight: true,
                allowTouchMove: false,
                loop: true, // 强制循环
                autoplay: autoplay && {
                    delay,
                    disableOnInteraction: false // 被用户交互之后，会继续自动播放
                },
                on: {
                    slideChange: (swiper) => {
                        activeIndex.value = swiper.realIndex;
                    }
                }
            });
        }
    };

    watch(swiperOptions, () => {
        destroySwiper();
        nextTick(initSwiper);
    });

    const slideTo = (index) => {
        swiperIns?.slideToLoop(index);
    };

    onMounted(() => {
        !isPreRender && nextTick(initSwiper);
    });

    onBeforeUnmount(() => {
        destroySwiper();
    });

    return {
        activeIndex,
        swiperRef,
        slideTo
    };
};
